/* eslint-disable */
/* eslint-disable no-unused-vars */
import React, { useEffect, useMemo, useState, useReducer } from "react";
import Table from "components/Table";
import api from "api";
import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useLoading, handleLoading } from "context/LoadingContext";
import { useAuth } from "context/auth";
import { dialogReducer, dialogInitState } from "reducers/dialog";
import Dialog from "components/Dialog/Dialog";
import useRoles from "customHooks/useRoles";
import Fatoora from "./Fatoora";
import Comment from "./Comment";
import addNewLog from "utils/addNewLog";
import { generateTextFromJson } from "utils/generateTextFromJson";
import { ErrorHandelFunctionApp } from "utils/ErrorHandelFunction";

function PaymentsLog() {
  const [, loadingDispatch] = useLoading();
  const [dataTable, setDataTable] = useState([]);
  const [sum, setSum] = useState(undefined);
  const [auth] = useAuth();
  const { permissions } = useRoles();
  const [paymentLogItem, setPaymentLogItem] = useState(null);

  const [fatooraDialogState, fatooraDispatchDialog] = useReducer(
    dialogReducer,
    dialogInitState
  );
  const [commentItem, setCommentItem] = useState(null);

  const [commentDialogState, commentDispatchDialog] = useReducer(
    dialogReducer,
    dialogInitState
  );

  // eslint-disable-next-line no-unused-vars
  const toggleFatoora = async(data) => {
    await addNewLog({
      ipAddress: auth.ipAddress,
      hostname: auth.hostname,
      logDescription: `${generateTextFromJson(data," الإرسالية المالية فاتورة")} `});
      
    if (data) setPaymentLogItem(data);
    else setPaymentLogItem(null);
    fatooraDispatchDialog({ type: "TOGGLE" });
  };
  const toggleComment = (data) => {
    if (data) setCommentItem(data);
    else setCommentItem(null);
    commentDispatchDialog({ type: "TOGGLE" });
  };

  //

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    getValues,
  } = useForm();
  const watchedData = watch();
  const headers = useMemo(
    () => [
      {
        accessorKey: "counter",
        header: "",
        cellClass: "table-printer-name",
      },
      {
        accessorKey: "paymentDate",
        header: "تاريخ الدفع",
        filterFn: "datePeriod",
        cell: (param) =>
          new Date(param.cell.row.original?.paymentDate).toLocaleString(
            "en-GB",
            {
              year: "numeric",
              month: "numeric",
              day: "numeric",
              timeZone: "UTC",
            }
          ) || "",
      },
      {
        accessorKey: "price",
        header: "المبلغ",
      },

      {
        accessorKey: "ePaymentNumber",
        header: "رقم الدفع الإلكتروني",
      },
      {
        accessorKey: "dlsKey",
        header: "الرقم المفتاحي",
      },
      {
        accessorKey: "receiptNumber",
        header: "رقم الوصل",
      },
      {
        accessorKey: "nationalNumber",
        header: "الرقم الوطني",
      },
      {
        accessorKey: "status",
        header: "الحالة",
        // eslint-disable-next-line react/no-unstable-nested-components
        cell: (param) => {
          const data = param.cell.row.original;
          return data.status ? "مدفوع" : "ملغي";
        },
      },
      {
        accessorKey: "actions",
        header: "",
        cellClass: "table__actions d-print-none",
        // eslint-disable-next-line react/no-unstable-nested-components
        cell: (param) => {
          const { status } = param.cell.row.original;
          let statusBadgeClass = "";
          if (status === null) {
            statusBadgeClass = "bg-secondary";
          } else {
            statusBadgeClass = status ? "bg-success" : "bg-danger";
          }
          return (
            <div className="table__actions__container">
              <button
                type="button"
                className="employee-requests__card__action badge badge--blue"
                onClick={toggleFatoora.bind(this, param.cell.row.original)}
              >
                فاتورة
              </button>
              {permissions?.employeeCanChangePaymentStatus && (
                <button
                  type="button"
                  className={`employee-requests__card__action badge ${statusBadgeClass}`}
                  onClick={toggleComment.bind(this, param.cell.row.original)}
                >
                  الحالة
                </button>
              )}

            </div>
          );
        },
      },
    ],
    [permissions]
  );
  //   paymentDate
  // price
  // dlsKey
  const exportHeaders = useMemo(
    () => ({
      paymentDateIso: "تاريخ الدفع",
      price: "المبلغ",
      ePaymentNumber: "رقم الدفع الإلكتروني",
      dlsKey: "الرقم المفتاحي",
      receiptNumber: "رقم الوصل",
      nationalNumber: "الرقم الوطني",
    }),
    []
  );

  const [printDateHeaderArr, setPrintDateHeaderArr] = useState(undefined);
  const getPaymentsLogs = async (data) => {
    try {
      handleLoading(loadingDispatch, true);
      const userLogsRes = await api.post("reports/paymentslogs", data);
      setSum(userLogsRes.data.data.sum);
      setDataTable(
        userLogsRes.data.data.list.map((item, idx) => ({
          ...item,
          counter: idx + 1,
          paymentDateIso: new Date(item.paymentDate).toLocaleString("en-GB", {
            year: "numeric",
            month: "numeric",
            day: "numeric",
            timeZone: "UTC",
          }),
        }))
      );
    } catch (error) {
      ErrorHandelFunctionApp(error)
    }
    handleLoading(loadingDispatch, false);
  };
  useEffect(() => {
    getPaymentsLogs();
  }, []);

  const onSubmit = (data) => {
    const { dateFrom, dateTo } = data;
    setPrintDateHeaderArr([dateFrom, dateTo]);
    getPaymentsLogs(data);
  };

  return (
    <>
      <h2 className="content__title title mt-3">الإرسالية المالية</h2>
      <form className="table__filter" onSubmit={handleSubmit(onSubmit)}>
        <div className="table__filter__period">
          <Form.Group className="input input-md date-input">
            <Form.Label>تاريخ الدفع من</Form.Label>
            <Form.Control
              type="date"
              {...register(`dateFrom`, {
                required: {
                  value: watchedData.dateTo,
                  message: "الرجاء ادخال الحقل",
                },
              })}
            />
          </Form.Group>
          <Form.Group className="input input-md date-input">
            <Form.Label>تاريخ الدفع إلى</Form.Label>
            <Form.Control
              type="date"
              {...register(`dateTo`, {
                required: {
                  value: watchedData.dateFrom,
                  message: "الرجاء ادخال الحقل",
                },
                validate: (dateTo) => {
                  if (!watchedData.dateFrom) return true;
                  return (
                    new Date(dateTo).getTime() >=
                      new Date(watchedData.dateFrom).getTime() ||
                    "الرجاء ادخال تاريخ صحيح"
                  );
                },
                deps: ["dateFrom"],
              })}
            />
            {errors.dateTo && (
              <Form.Text className="text-danger">
                {errors.dateTo.message}
              </Form.Text>
            )}
          </Form.Group>
        </div>
        <Form.Group className="input input-md date-input">
          <Form.Label>الرقم المفتاحي</Form.Label>
          <Form.Control {...register(`dlsKey`)} />
          {errors.dlsKey && (
            <Form.Text className="text-danger">
              {errors.dlsKey.message}
            </Form.Text>
          )}
        </Form.Group>
        <div
          className="table__filter__actions"
          style={{ alignSelf: "flex-end" }}
        >
          <button type="submit" className="btn btn--primary fw-bold">
            بحث
          </button>
        </div>
      </form>
      <div>
        <Table
          data={dataTable}
          columns={headers}
          printable
          exportHeaders={exportHeaders}
          headerTitle="الارسالية المالية لمخطط موقع وترسيم "
          exportName="الارسالية المالية لمخطط موقع وترسيم "
          printDateHeaderArr={printDateHeaderArr}
          sum={sum}
          sumTitle="المجموع بالدينار"
          printerName={
            auth?.userDetails?.details?.fullName?.trim() ||
            `${auth?.userDetails?.details?.firstName}
            ${auth?.userDetails?.details?.lastName}`
          }
        />
      </div>

      <Dialog
        state={fatooraDialogState}
        dispatch={fatooraDispatchDialog}
        footer={false}
        closeButton
        dialogClassName="violation_modal"
      >
        <Fatoora
          paymentLogItem={paymentLogItem}
          user={`${auth?.userDetails?.details?.firstName} ${auth?.userDetails?.details?.lastName}`}
        />
      </Dialog>
      <Dialog
        state={commentDialogState}
        dispatch={commentDispatchDialog}
        footer={false}
        closeButton
        dialogClassName="violation_modal"
        centered
        title="تعديل الحالة"
      >
        <Comment
          comment={commentItem}
          getPaymentsLogs={() => getPaymentsLogs(getValues())}
          toggleComment={toggleComment}
        />
      </Dialog>
    </>
  );
}

export default PaymentsLog;
